// import React, { useState, useEffect } from "react";
// import api from "../../../api/axios";

// export default function ReportsPage() {
//   const [reportType, setReportType] = useState("occupancy");
//   const [fromDate, setFromDate] = useState("2025-12-01");
//   const [toDate, setToDate] = useState("2025-12-07");

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchReport = async () => {
//     setLoading(true);
//     setData(null);

//     const res = await api.get(
//       `/pms/reports/${reportType}?from_date=${fromDate}&to_date=${toDate}`
//     );

//     setData(res.data);
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchReport();
//   }, [reportType]);

//   return (
//     <div className="container py-4">
//       {/* Simple Filter Section */}
//       <div className="card mb-4">
//         <div className="card-body row gy-3">
//           <div className="col-md-3">
//             <label className="form-label fw-bold">Report</label>
//             <select
//               className="form-select"
//               value={reportType}
//               onChange={(e) => setReportType(e.target.value)}
//             >
//               <option value="occupancy">Occupancy</option>
//               <option value="revenue">Revenue</option>
//               <option value="reservations">Reservations</option>
//               <option value="housekeeping">Housekeeping</option>
//               <option value="payments">Payments</option>
//               <option value="audit">Audit Log</option>
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="date"
//               className="form-control"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="date"
//               className="form-control"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//             />
//           </div>

//           <div className="col-md-3 d-flex align-items-end">
//             <button className="btn btn-primary w-100" onClick={fetchReport}>
//               Load Report
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Loading */}
//       {loading && (
//         <div className="text-center py-4">
//           <div className="spinner-border text-primary"></div>
//           <p className="mt-2 text-muted">Loading...</p>
//         </div>
//       )}

//       {/* Table */}
//       {!loading && data?.table && (
//         <div className="card">
//           <div className="card-body">
//             <div className="table-responsive">
//               <table className="table table-bordered table-striped">
//                 <thead>
//                   <tr>
//                     {Object.keys(data.table[0]).map((col) => (
//                       <th key={col}>{col.toUpperCase()}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.table.map((row, i) => (
//                     <tr key={i}>
//                       {Object.values(row).map((cell, j) => (
//                         <td key={j}>{cell}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* No Data */}
//       {!loading && data?.table?.length === 0 && (
//         <p className="text-muted text-center">No records found.</p>
//       )}
//     </div>
//   );
// }

import React, { useState } from "react";
import ReportsHome from "./ReportsHome";

export default function ReportsPage() {
  const [reportType, setReportType] = useState(null);
  const [data, setData] = useState(null);

  // ---------------------------------------------------
  // SAMPLE DATA FOR ALL REPORTS (Matches your PNG)
  // ---------------------------------------------------
  const sampleReports = {
    // ---------------- FRONT OFFICE -----------------
    arrival_list: {
      title: "Arrival List",
      table: [
        { guest: "John Doe", room: "101", checkin: "2025-12-05" },
        { guest: "Priya", room: "203", checkin: "2025-12-05" },
      ],
    },
    departure_list: {
      title: "Departure List",
      table: [
        { guest: "Daniel", room: "105", checkout: "2025-12-05" },
        { guest: "Asha", room: "110", checkout: "2025-12-05" },
      ],
    },
    inhouse_list: {
      title: "In-House Guest List",
      table: [
        { guest: "Sandeep", room: "202", since: "2025-12-02" },
        { guest: "Kim", room: "303", since: "2025-12-01" },
      ],
    },
    room_status: {
      title: "Room Status Report",
      table: [
        { room: "101", status: "Occupied" },
        { room: "102", status: "Vacant" },
        { room: "103", status: "Cleaning" },
      ],
    },
    occupancy: {
      title: "Occupancy Report",
      table: [
        { date: "2025-12-01", rooms: 40, occupied: 32, occupancy: "80%" },
        { date: "2025-12-02", rooms: 40, occupied: 28, occupancy: "70%" },
      ],
    },
    reservation_report: {
      title: "Reservations Report",
      table: [
        { guest: "Rani", room_type: "Deluxe", date: "2025-12-03" },
        { guest: "Omkar", room_type: "Suite", date: "2025-12-02" },
      ],
    },
    expected_arrivals: {
      title: "Expected Arrivals",
      table: [{ guest: "Manoj", room: "201", arrival: "2025-12-06" }],
    },
    expected_departures: {
      title: "Expected Departures",
      table: [{ guest: "Vikas", room: "402", departure: "2025-12-05" }],
    },
    cancelled_reservations: {
      title: "Cancelled Reservations",
      table: [{ guest: "Rohit", date: "2025-12-04" }],
    },
    no_show: {
      title: "No-Show Reservations",
      table: [{ guest: "Amir", date: "2025-12-03" }],
    },
    checkedout_guests: {
      title: "Checked-Out Guests",
      table: [{ guest: "Nisha", room: "105", date: "2025-12-04" }],
    },

    // ---------------- MANAGEMENT -----------------
    daily_revenue: {
      title: "Daily Revenue Summary",
      table: [
        { date: "2025-12-01", revenue: 15000 },
        { date: "2025-12-02", revenue: 17000 },
      ],
    },
    room_revenue: {
      title: "Room Revenue Report",
      table: [
        { room_type: "Deluxe", revenue: 12000 },
        { room_type: "Suite", revenue: 23000 },
      ],
    },
    manager_flash: {
      title: "Manager Flash Report",
      table: [
        { metric: "Total Rooms", value: 40 },
        { metric: "Occupied", value: 32 },
      ],
    },
    sales_report: {
      title: "Daily Sales Report",
      table: [{ date: "2025-12-01", sales: 45000 }],
    },
    housekeeping_status: {
      title: "Housekeeping Status",
      table: [
        { room: "101", status: "Clean" },
        { room: "102", status: "Pending" },
      ],
    },
    room_cleaning: {
      title: "Room Cleaning Report",
      table: [{ room: "103", staff: "Meena", status: "In Progress" }],
    },
    laundry_report: {
      title: "Laundry Report",
      table: [
        { item: "Bedsheet", qty: 30 },
        { item: "Towels", qty: 50 },
      ],
    },
    night_audit: {
      title: "Night Audit Summary",
      table: [
        { section: "Revenue", value: 54000 },
        { section: "Payments", value: 33000 },
      ],
    },
    reconciliation: {
      title: "Reconciliation Report",
      table: [{ type: "Cash", system: 5000, actual: 4800 }],
    },

    // ---------------- GROUPS -----------------
    group_summary: {
      title: "Group Summary",
      table: [{ group: "TCS Team", rooms: 10, revenue: 55000 }],
    },
    group_rooming: {
      title: "Group Rooming List",
      table: [{ guest: "Mahesh", room: "301" }],
    },
    group_revenue: {
      title: "Group Revenue Report",
      table: [{ group: "Infosys", revenue: 72000 }],
    },
    group_pickup: {
      title: "Group Pickup Report",
      table: [{ group: "Wipro", picked: 5, total: 7 }],
    },
    group_booking_status: {
      title: "Group Booking Status",
      table: [{ group: "Google", status: "Confirmed" }],
    },
    group_reservation: {
      title: "Group Reservation Details",
      table: [{ group: "Capgemini", date: "2025-12-10" }],
    },

    // ---------------- ACCOUNTING -----------------
    payment_summary: {
      title: "Payment Summary",
      table: [
        { mode: "UPI", amount: 9000 },
        { mode: "Cash", amount: 7000 },
      ],
    },
    collection_report: {
      title: "Collection Report",
      table: [{ date: "2025-12-01", collected: 14000 }],
    },
    refund_report: {
      title: "Refund Report",
      table: [{ guest: "Nitin", amount: 1200 }],
    },
    pending_payments: {
      title: "Pending Payments",
      table: [{ guest: "Arjun", due: 2000 }],
    },
    guest_ledger: {
      title: "Guest Ledger",
      table: [{ guest: "Ravi", balance: 550 }],
    },
    city_ledger: {
      title: "City Ledger",
      table: [{ company: "IBM", balance: 15000 }],
    },
    cashier_report: {
      title: "Cashier Report",
      table: [{ cashier: "Riya", amount: 32000 }],
    },
    folio_statement: {
      title: "Folio Statement",
      table: [{ guest: "Manish", total: 4500 }],
    },
    revenue_breakdown: {
      title: "Revenue Breakdown",
      table: [
        { section: "Rooms", amount: 35000 },
        { section: "F&B", amount: 12000 },
      ],
    },
    tax_summary: {
      title: "Tax Summary Report",
      table: [{ tax: "GST", amount: 3200 }],
    },
  };

  // ---------------------------------------------------
  // REPORT GROUPS (exactly like the PNG)
  // ---------------------------------------------------
  const reportGroups = [
    {
      title: "Front Office",
      items: [
        { key: "arrival_list", label: "Arrival List" },
        { key: "departure_list", label: "Departure List" },
        { key: "inhouse_list", label: "In-House Guest List" },
        { key: "room_status", label: "Room Status Report" },
        { key: "occupancy", label: "Occupancy Report" },
        { key: "reservation_report", label: "Reservation Report" },
        { key: "expected_arrivals", label: "Expected Arrivals" },
        { key: "expected_departures", label: "Expected Departures" },
        { key: "cancelled_reservations", label: "Cancelled Reservations" },
        { key: "no_show", label: "No-Show Reservations" },
        { key: "checkedout_guests", label: "Checked-Out Guests" },
      ],
    },

    {
      title: "Management",
      items: [
        { key: "daily_revenue", label: "Daily Revenue Summary" },
        { key: "room_revenue", label: "Room Revenue Report" },
        { key: "manager_flash", label: "Manager Flash Report" },
        { key: "sales_report", label: "Daily Sales Report" },
        { key: "housekeeping_status", label: "Housekeeping Status" },
        { key: "room_cleaning", label: "Room Cleaning Report" },
        { key: "laundry_report", label: "Laundry Report" },
        { key: "night_audit", label: "Night Audit Summary" },
        { key: "reconciliation", label: "Reconciliation Report" },
      ],
    },

    {
      title: "Groups",
      items: [
        { key: "group_summary", label: "Group Summary" },
        { key: "group_rooming", label: "Group Rooming List" },
        { key: "group_revenue", label: "Group Revenue Report" },
        { key: "group_pickup", label: "Group Pickup Report" },
        { key: "group_booking_status", label: "Group Booking Status" },
        { key: "group_reservation", label: "Group Reservation Details" },
      ],
    },

    {
      title: "Accounting",
      items: [
        { key: "payment_summary", label: "Payment Summary" },
        { key: "collection_report", label: "Collection Report" },
        { key: "refund_report", label: "Refund Report" },
        { key: "pending_payments", label: "Pending Payments" },
        { key: "guest_ledger", label: "Guest Ledger" },
        { key: "city_ledger", label: "City Ledger" },
        { key: "cashier_report", label: "Cashier Report" },
        { key: "folio_statement", label: "Folio Statement" },
        { key: "revenue_breakdown", label: "Revenue Breakdown" },
        { key: "tax_summary", label: "Tax Summary Report" },
      ],
    },
  ];

  const loadSample = (key) => {
    setReportType(key);
    setData(sampleReports[key]);
  };

  return (
    // <div className="container py-4">
    //   <h3 className="fw-bold mb-4">Reports</h3>

    //   {/* REPORT BOXES */}
    //   <div className="row g-4">
    //     {reportGroups.map((group, idx) => (
    //       <div key={idx} className="col-md-4">
    //         <div className="card shadow-sm">
    //           <div className="card-body">
    //             <h5 className="fw-bold mb-3">{group.title}</h5>

    //             <select
    //               className="form-select mb-3"
    //               onChange={(e) => loadSample(e.target.value)}
    //             >
    //               <option value="">Select Report</option>
    //               {group.items.map((item) => (
    //                 <option key={item.key} value={item.key}>
    //                   {item.label}
    //                 </option>
    //               ))}
    //             </select>

    //             <button
    //               className="btn btn-primary w-100"
    //               disabled={!reportType}
    //               onClick={() => loadSample(reportType)}
    //             >
    //               Load Report
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     ))}
    //   </div>

    //   {/* REPORT TABLE */}
    //   {data && (
    //     <div className="card mt-5 shadow-sm">
    //       <div className="card-body">
    //         <h4 className="fw-bold mb-3">{data.title}</h4>

    //         <div className="table-responsive">
    //           <table className="table table-bordered table-striped">
    //             <thead>
    //               <tr>
    //                 {Object.keys(data.table[0]).map((key) => (
    //                   <th key={key}>{key.toUpperCase()}</th>
    //                 ))}
    //               </tr>
    //             </thead>
    //             <tbody>
    //               {data.table.map((row, i) => (
    //                 <tr key={i}>
    //                   {Object.values(row).map((cell, j) => (
    //                     <td key={j}>{cell}</td>
    //                   ))}
    //                 </tr>
    //               ))}
    //             </tbody>
    //           </table>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </div>

    <ReportsHome />
  );
}
